<template>
  <div id="recording-tab-public">
    <!-- modal -->
    <vs-popup
      width="300px"
      not-center
      v-model="showContactsModal"
      class="modal"
      title="Selecionar Contatos"
      :active.sync="showContactsModal"
    >
      <div class="items-center flex container-filter">
        <div class="container-select">
          <select
            id="participant-filter"
            class="input-select mt-2 mb-2"
            :class="{ hiddens: false }"
            name="filter"
            label=""
            data-vv-as="'Filtro'"
            v-model="searchField"
          >
            <option
              :key="item.id"
              :value="item.field"
              v-for="item in filterOptions"
            >
              {{ item.name }}
            </option>
          </select>
        </div>
        <div class="filter-participants">
          <vs-input
            label=""
            icon=""
            style="width: 100%"
            :placeholder="getPlaceholder"
            v-model="searchTerms"
            :type="searchField === 'name' ? 'text' : 'number'"
            @input="inputCheckSearch"
            id="filter-participants"
            name="search"
          />
          <feather-icon
            v-if="isSearching && isFetching"
            class="input-icon-btn cursor-pointer"
            icon="MoreHorizontalIcon"
            svgClasses="h-5 w-5"
          />
          <!--          <feather-icon
            v-else-if="!isSearching && !isFetching"
            class="input-icon-btn cursor-pointer"
            icon="SearchIcon"
            @click="
              () => {
                if (showParticipantSearch) {
                  inputCheckSearch(true);
                } else {
                  fetchParticipants();
                }
              }
            "
            svgClasses="h-5 w-5"
          />-->
        </div>
      </div>

      <div class="modal-bottom-row">
        <div class="selected-contacts-container">
          <div
            class="participants-msg"
            v-if="filteredParticipants.length && !idArray.length"
          >
            <p><strong>Nenhum</strong> contato selecionado</p>
          </div>
          <div
            class="participants-msg"
            v-if="filteredParticipants.length && idArray.length"
          >
            <span class="selected-number"
              ><strong>{{ idArray.length }} </strong>
            </span>
            <span class="selected-text" v-if="idArray.length === 1">
              selecionado</span
            >
            <span class="selected-text" v-if="idArray.length > 1"
              >selecionados
            </span>
          </div>
          <span
            class="clear-selected text-primary cursor-pointer"
            v-if="idArray.length"
            @click="clearSelected"
            >Limpar</span
          >
        </div>

        <button
          v-if="idArray.length"
          @click="addMultipleParticipantsAndCloseModal"
          class="vs-button vs-button-primary vs-button-filled"
        >
          <!--          <i class="fa fa-plus" style="margin-right: 5px"></i>-->
          <span>Adicionar</span>
        </button>
      </div>
      <div style="min-height: 300px; padding-top: 16px">
        <!-- Pesquisar/Adicionar participantes -->
        <participants-search
          ref="searchList"
          v-show="showContactsModal"
          @updateArr="updateArr"
          :data="{
            searchField,
            searchTerms,
            recordingId,
            isSearching,
          }"
          :searching="isSearching"
          :showContactsModal="showContactsModal"
          v-infinite-scroll="autoloadMoreResults"
          infinite-scroll-disabled="waitToSearchMore"
          infinite-scroll-distance="0"
          infinite-scroll-throttle-delay="200"
        />
      </div>
    </vs-popup>

    <vx-card
      style="background: #f7f7f7; border-top: 1px solid #eee"
      class="mb-base"
      id="data-cardlist-list"
    >
      <div class="vx-row w-full">
        <div
          id="closed-list-content"
          v-if="caravanist && caravanist.participantListClosedAt"
        >
          <button>
            <i class="fa fa-ban" style="margin-right: 5px"></i>
            <span>Lista encerrada!</span>
          </button>
        </div>
        <!--          Select Contact Float Button-->
        <div
          id="cardlist-content"
          class="w-full mt-0"
          v-if="caravanist && !caravanist.participantListClosedAt"
        >
          <button
            v-if="
              participants.length
                ? !participants[0].recording.participantsListClosed
                : true
            "
            class="btn-participants-toggle vs-button vs-button-primary vs-button-filled"
            :class="showParticipantSearch ? 'search' : ''"
            style="
              width: 190px;
              height: 50px;
              z-index: 9999;
              display: flex;
              flex-direction: column;
              align-items: center;
            "
            @click="
              () => {
                agoraVai();
                // addMultiParticipants();
                setFilter();
              }
            "
          >
            <i class="fa fa-user" />
            <span>Adicionar Contato</span>
          </button>
        </div>

        <div class="container-infos">
          <vs-row style="padding-left: 16px">
            <vs-chip class="legend-chip">
              <span class=""
                ><span class="status-badge-span">{{ totalItems }}</span>
                Convidado</span
              >
            </vs-chip>
            <vs-chip class="legend-chip confirm-chip">
              <span class=""
                ><span class="status-badge-span">{{ totalConfirmed }}</span>
                Confirmado</span
              >
            </vs-chip>
            <vs-chip class="legend-chip pendent-chip">
              <span class=""
                ><span class="status-badge-span">{{ totalNotConfirmed }}</span>
                Pendente</span
              >
            </vs-chip>
          </vs-row>
        </div>

        <div
          id="infinite-scroll-participants"
          class="w-full"
          :participants="participants.length"
          :search="filteredParticipants.length"
        >
          <!-- Lista os participantes -->
          <participants-list
            v-show="true"
            :data="{ participants, caravanist }"
            @refreshItems="fetchParticipants"
            v-infinite-scroll="autoloadMoreParticipants"
            infinite-scroll-disabled="waitToFetchMore"
            infinite-scroll-distance="0"
            infinite-scroll-throttle-delay="800"
          />
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import ParticipantsList from "./ParticipantsList";
import ParticipantsSearch from "./ParticipantsSearch";

export default {
  components: {
    ParticipantsList,
    ParticipantsSearch,
  },
  props: {
    data: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      caravanist: null,
      timerRequest: null,
      timerInputDelay: null,
      idArray: [],
      activeSearchPage: 1,
      activeParticipantsPage: 1,
      maxParticipantsPage: 1,
      maxSearchPage: 1,
      offset: 0,
      isFetching: false,
      showParticipantSearch: false,
      isSearching: false,
      searchField: "name",
      searchTerms: "",
      participantsTerms: "",
      shouldSkipSearch: false,
      showContactsModal: false,
      isCreatingAssociation: false,
    };
  },
  computed: {
    /*reloadItems() {
      this.fetchParticipants();
    },
    reloadParticipantsListTab() {
      this.fetchParticipants();
    },*/
    getPlaceholder() {
      switch (this.searchField) {
        case "age":
          return "Filtrar por idade (Ex: 20)";
        case "mobile":
          return "Procurar celulares (Ex: 11912345678)";
        default:
          return "Pesquisar nomes (Ex: Maria Silva)";
      }
    },
    recordingId() {
      return this.$route.params.id;
    },
    recordingData() {
      return this.$store.state.recording.single;
    },
    filteredParticipants() {
      return this.$store.state.recording.searchList;
    },
    itemsPerPage() {
      return this.data.itemsPerPage || 25;
    },
    participants() {
      return this.$store.state.recording.participants || [];
    },
    totalItems() {
      return this.$store.state.recording.totalParticipants || 0;
    },
    totalConfirmed() {
      let count = 0;
      this.$store.state.recording.participants.map((item) => {
        if (item.status === true) count++;
        return count;
      });
      return count || 0;
    },
    totalNotConfirmed() {
      return parseInt(this.totalItems) - parseInt(this.totalConfirmed);
    },
    totalSearch() {
      return this.$store.state.recording.totalSearch;
    },
    filterOptions() {
      return [
        { id: 0, field: "name", name: "Nome" },
        { id: 1, field: "mobile", name: "Celular" },
        { id: 2, field: "age", name: "Idade" },
      ];
    },
    canSearch() {
      return (
        !this.searchTerms ||
        (this.searchField === "name" && this.searchTerms.length > 2) ||
        (this.searchField !== "name" && this.searchTerms.length > 0)
      );
    },
    waitToFetchMore() {
      if (this.showParticipantSearch) return true;
      if (this.activeParticipantsPage <= this.maxParticipantsPage) {
        return this.isFetching;
      }

      return false;
    },
    waitToSearchMore() {
      if (!this.showParticipantSearch) return true;
      if (this.activeSearchPage <= this.maxSearchPage) {
        return this.isSearching;
      }

      return false;
    },
  },
  methods: {
    autoloadMoreParticipants() {
      if (
        this.participants.length === 0 ||
        this.participants.length < this.totalItems
      ) {
        this.fetchParticipants(this.participants.length > 0);
      }
    },
    autoloadMoreResults() {
      if (
        (this.filteredParticipants.length === 0 &&
          !this.shouldSkipSearch &&
          this.activeSearchPage === 1) ||
        (this.totalSearch > 0 &&
          this.filteredParticipants.length < this.totalSearch)
      ) {
        this.shouldSkipSearch = true;
        this.searchParticipants(this.filteredParticipants.length > 0);
      }
    },
    updateArr(arr) {
      this.idArray = arr;
    },
    clearSelected(clearAll = false) {
      this.$refs.searchList.clearSelected();
      if (clearAll === true) {
        this.$store.dispatch("recording/clearParticipants");
      }
    },
    setFilter() {
      this.showParticipantSearch = !this.showParticipantSearch;
      // clears the current search results
      if (!this.showParticipantSearch && this.idArray.length) {
        this.clearSelected();
      }
    },
    inputCheckSearch(btnPressed) {
      if (this.timerInputDelay) {
        clearTimeout(this.timerInputDelay);
        this.timerInputDelay = null;
      }

      this.timerInputDelay = setTimeout(
        () => {
          if (this.canSearch) {
            this.searchParticipants();
          }
        },
        btnPressed === true ? 0 : 800
      );
    },
    inputCheckParticipants(btnPressed) {
      if (!this.showParticipantSearch) {
        if (this.timerInputDelay) {
          clearTimeout(this.timerInputDelay);
          this.timerInputDelay = null;
        }

        this.timerInputDelay = setTimeout(
          () => {
            if (this.canSearch) {
              this.fetchParticipants();
            }
          },
          btnPressed === true ? 0 : 800
        );
      }
    },
    toastMsg(msg, success = true) {
      this.$vs.notify({
        text: msg,
        color: success ? "success" : "danger",
        iconPack: "feather",
        icon: "icon-alert-circle",
        time: 10000,
        position: "bottom-left",
      });
    },
    agoraVai() {
      this.showContactsModal = true;
    },
    addMultipleParticipantsAndCloseModal() {
      this.showContactsModal = false;
      const currentParticipants = [];
      this.idArray.forEach((id) => {
        currentParticipants.push({ id });
      });
      if (currentParticipants.length <= 0) return;
      this.isCreatingAssociation = true;
      this.setLoading(true);
      this.$store
        .dispatch("recording/addRecordingParticipants", {
          recordingId: this.data.recordingId,
          participants: currentParticipants,
        })
        .then((res) => {
          this.searchTerms = "";
          this.participantsTerms = "";
          this.isCreatingAssociation = false;

          this.isFetching = false;
          this.$router.push({ name: "gravacoes-detalhes" });

          let rName = "nesta gravação";
          const rec = this.recordingData.recording;

          if (rec) {
            if (rec.program && rec.program.name) {
              rName = `programa "${rec.program.name}"`;
              if (rec.grame && rec.grame.name) {
                rName = `quadro "${rec.grame.name}" no ` + rName;
              }
              rName = "à gravação do " + rName;
            }
          }

          const msg = `Você adicionou novos participantes ${rName}!`;

          this.toastMsg(msg);
          this.idArray = [];
        })
        .finally(() => {
          this.fetchParticipants();
          this.isFetching = false;
        });
    },
    fetchParticipants(increment = false) {
      if (this.isFetching) return;
      const itemsPerPage = this.itemsPerPage;

      if (increment) {
        this.activeParticipantsPage++;
      } else {
        this.activeParticipantsPage = 1;
      }

      const field = this.searchField;
      const terms = this.participantsTerms;
      const recordingId = this.recordingId;
      const limit = itemsPerPage;
      const offset = (this.activeParticipantsPage - 1) * itemsPerPage;

      this.isFetching = true;
      this.setLoading(true);

      this.$store
        .dispatch("recording/fetchParticipants", {
          field,
          terms,
          recordingId,
          limit,
          offset,
          increment,
        })
        .finally(() => {
          this.setLoading(false);
          this.isFetching = false;
          this.maxParticipantsPage = Math.ceil(
            this.totalItems / this.itemsPerPage
          );
        });
    },
    searchParticipants(increment = false) {
      if (this.isSearching) return;

      const itemsPerPage = this.itemsPerPage;

      if (increment) {
        this.activeSearchPage++;
      } else {
        this.activeSearchPage = 1;
      }

      const field = this.searchField;
      const terms = this.searchTerms;
      const recordingId = this.recordingId;
      const limit = 100;
      const offset = (this.activeSearchPage - 1) * itemsPerPage;

      this.isSearching = true;
      this.setLoading(true);

      this.$store
        .dispatch("recording/searchParticipants", {
          field,
          terms,
          limit,
          offset,
          increment,
          recordingId,
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.clearSelected();
          this.isSearching = false;
          this.setLoading(false);
          this.maxSearchPage = parseInt(this.totalSearch / this.itemsPerPage);
        });
    },
    setLoading(active = true) {
      if (active) {
        this.$vs.loading({
          container: "#cardlist-content",
          scale: 0.6,
        });
      } else {
        this.$vs.loading.close("#cardlist-content > .con-vs-loading");
      }
    },
  },
  mounted() {
    // Executa a busca por participantes vazios ao abrir o modal
    this.$watch("showContactsModal", (newValue, oldValue) => {
      if (newValue) {
        console.log("Abriu o modal. Buscando contatos");
        this.searchParticipants();
      }
    });

    this.caravanist = this.data.recording.caravanist;
    this.setLoading(false);
  },
};
</script>

<style lang="scss">
.selected-contacts-container {
  font-size: 13px !important;
  display: flex;
  flex-direction: row;
  gap: 6px;
  background-color: rgba(255, 255, 255, 0.9);
  padding: 8px;
  border-radius: 16px;
}
.tab-gray {
  background: red;
}
.modal-bottom-row {
  position: absolute;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  bottom: 20px;
  left: 15px;
  right: 15px;
  padding: 10px;
  z-index: 100;
  background: rgba(0, 0, 0, 0.6);
  border-radius: 6px;
}

.container-infos .text-chip {
  margin-left: 5px;
}
.status-badge-span {
  background-color: #fff;
  border-radius: 3px;
  margin: 0 !important;
  width: 14px;
  padding: 2px 3px;
  font-weight: bold;
  border: 0;
  text-align: center;
  justify-content: center;
}
.legend-chip {
  display: flex;
  padding: 2px;
  align-items: center;
  flex-direction: row;
  border-radius: 5px;
  border: 1px solid;
}
.checkin-chip {
  background-color: #9eceff;
  border: 1px solid #1e90ff;
  color: #1e90ff;
}
.confirm-chip {
  background-color: #45d458;
  border: 1px solid #acffb7;
  color: #6ddb7c;
}
.pendent-chip {
  background-color: #ffaa41;
  border: 1px solid #ffd29b;
  color: #ffaa41;
}

.bg-card-pendent {
  border-left-width: 8px !important;
  background: #fff !important;
  border-color: #ffaa41 !important;
}
.bg-card-success {
  border-left-width: 8px !important;
  border-color: #6ddb7c !important;
  background: #fff !important;
}
.bg-card-checkin {
  border: 1px solid #1e90ff;
  background-color: #e9f4ff;
  color: #fff !important;
}

.button-closed-list {
  position: absolute !important;
  z-index: 3;
  right: 1px;
  bottom: 0;
  margin-bottom: 30px;
  padding: 9px;
  border: none;
  background: red;
  border-radius: 4px;
}
.vue-back-to-top {
  right: 85% !important;
}
#cardlist-content {
  button {
    position: fixed;
    width: 45px;
    height: 45px;
    bottom: 5%;
    right: 5%;
    &.search {
      background-color: green !important;
    }
    .icon {
      display: contents;
      padding-bottom: 8px;
      position: relative;
    }
  }
}
#closed-list-content {
  button {
    position: fixed;
    z-index: 999;
    width: 170px;
    font-size: 16px;
    border: 0;
    justify-content: center;
    align-items: center;
    display: flex;
    height: 56px;
    bottom: 1%;
    right: 1%;
    border-radius: 5px;
    background-color: #a51818 !important;
    box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease 0s;
    color: #fff;
    .icon {
      display: contents;
      padding-bottom: 8px;
      position: relative;
    }
  }
}

#recording-tab-public {
  .participants-msg {
    background-color: #fff;
    padding: 0 0 2px 2px;
    .selected-text {
      font-size: 0.9em;
    }
    .clear-selected {
      margin: 0 0 0 10px;
    }
    .selected-number,
    .clear-selected {
      font-weight: bold;
      font-size: 16px;
    }
  }
  .hidden-item {
    visibility: hidden;
  }
  .vx-card__body {
    padding: 0;
  }
  .cardlist-logo {
    float: left;
    clear: none;
    .logo-container {
      display: flex;
      clear: none;
      float: left;
      margin-bottom: 1em;
      .rounded-letter,
      img.rounded {
        height: 42px;
        margin: auto;
      }
      img.rounded {
        width: auto;
        height: 42px;
      }
      .rounded-letter {
        padding: 7px 0 0 0;
        width: 42px;
        height: 42px;
        display: block;
        text-align: center;
        font-size: 2.3em;
        border-radius: 100%;
        line-height: 100%;
        background-color: #fff;
        border: 1px solid rgba(0, 0, 0, 0.2);
        color: #222;
        opacity: 0.6;
      }
    }
  }
  .vs-card--content {
    width: 100%;
    display: inline-table;
    margin-bottom: 0;
    .cardlist-row {
      width: calc(100% - 60px);
      float: right;
    }
  }
  .cardlist-data-recordings {
    border: 1px solid rgba(0, 0, 0, 0.1);
    margin: 10px 0;
    .cardlist-item {
      margin-top: 2px;
      &.item-status {
        margin-top: 12px;
        span {
          float: left;
        }
        .feather-icon {
          margin: -4px 0 -1px 30px;
        }
      }
    }
  }
  .filter-participants {
    width: calc(100% - 120px);
    position: relative;
    .vs-input {
      width: 100%;
    }
    .vs-con-input {
      width: 100%;
      input {
        width: 100%;
        &.hasIcon {
          padding-right: 3em !important;
        }
      }
      .vs-input--icon {
        font-size: 1.4rem;
        top: 10px;
      }
    }
    .input-icon-btn {
      position: absolute !important;
      z-index: 3;
      top: 1px;
      right: 1px;
      padding: 9px;
      border: none;
      background: #eee;
      border-radius: 4px;
    }
  }
}
@media screen and (max-width: 539px) {
  #recording-tab-public {
    .participants-msg {
      padding-top: 15px;
    }
  }
  #cardlist-content {
    .con-vs-loading {
      top: 50%;
      position: fixed !important;
    }
    > div {
      &.items-center {
        display: block !important;
      }
      .filter-participants,
      .participant-filter {
        margin-top: 10px;
        float: left;
        width: 100%;
      }
    }
    .cardlist-row {
      &:nth-last-of-type(2) {
        .cardlist-item:last-of-type {
          display: none;
        }
      }
    }
  }
  #recording-tab-public {
    .cardlist-item.hidden-item {
      display: none;
    }
  }
}
@media screen and (min-width: 540px) {
  #recording-tab-public {
    .filter-participants {
      width: 100%;
    }
    .participant-filter {
      + .filter-participants {
        margin-left: 10px;
        width: calc(100% - 345px);
      }
    }
    .cardlist-logo {
      display: block;
      .logo-container {
        margin-bottom: 0;
      }
    }
    .con-vs-card {
      &:not(:last-of-type) {
        margin-bottom: 0;
      }
      .cardlist-row {
        width: calc(100% - 60px);
        float: left;
        display: flex;
        margin: 0 0 0 12px;
        + .cardlist-row {
          margin-top: 6px;
        }
        .cardlist-item {
          flex-grow: 1;
          flex-basis: 0;
        }
      }
    }
    .cardlist-data-recordings {
      .cardlist-item {
        &.item-status {
          margin-top: 0;
        }
      }
    }
  }
}
.container-infos {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: left;
  text-align: end;
  margin-left: 0;
  @media screen and (max-width: 640px) {
    margin: auto;
    padding: 16px 0;
    text-align: start;
  }
}
.bg-light-blue {
  background-color: rgba(30, 144, 255, 0.2) !important;
  border-color: rgba(30, 144, 255, 0.3) !important;
}

.icon-blue {
  color: #1e90ff;
}

.container-select {
  width: 50%;
  margin-right: 20px;
  @media (max-width: 768px) {
    width: 100%;
    margin: 0;
  }
}
.container-filter {
  @media (max-width: 768px) {
    display: block !important;
  }
}
.container-button {
  margin-right: 0 auto;
}
</style>
